import { RuleModel } from '../../models/RuleModel';
import { ActionBase } from '../../../core/store/action/ActionBase';

export const UPDATE_RULE_STATUS = '[Rule] Rule Status Update';

export class UpdateRuleStatusAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = UPDATE_RULE_STATUS;

  constructor(public payload: { rule: RuleModel }) {}
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/actions/UpdateRuleStatusAction.ts